// EDIT ME
export const remote_data_host = 'https://ncucf-data.s3.amazonaws.com/data';
export const ga_tracking_id = 'UA-83813049-1';
